
import { defineComponent, computed, ref, onMounted } from "vue";
import { useMainStore } from "@/stores/mainStore";
import Spinner from "@/components/ui/Spinner.vue";
import Tooltip from "@/components/ui/Tooltip.vue";

export default defineComponent({
	name: "UserGamificationCard",
	components: { Spinner, Tooltip },
	props: {
		courseId: {
			type: String,
			required: true,
		},
	},
	setup(props) {
		const mainStore = useMainStore();
		const loading = ref(false);

		const gamificationContext = computed(() => mainStore.gamificationContext);

		const rankIcon = computed(() => {
			const pos = gamificationContext.value?.leaderboard_position;
			if (pos === 1) return "emoji_events";
			if (pos === 2 || pos === 3) return "military_tech";
			return "leaderboard";
		});

		const rankIconColor = computed(() => {
			const pos = gamificationContext.value?.leaderboard_position;
			if (pos === 1) return "text-yellow-400";
			if (pos === 2) return "text-gray-400";
			if (pos === 3) return "text-yellow-700";
			return "text-muted";
		});

		onMounted(async () => {
			loading.value = true;
			try {
				await mainStore.getCourseGamificationContext({ courseId: props.courseId });
			} finally {
				loading.value = false;
			}
		});

		return { loading, gamificationContext, rankIcon, rankIconColor };
	},
});
